import React from "react";
import {CheckCircleFilled, WarningOutlined} from "@ant-design/icons";
import {NType} from "./interface";

export const PALETTE: Record<NType, { fg: string; bg: string; ring: string; icon: React.ReactNode }> = {
    error:   { fg: "#d03d07", bg: "#fff6f2", ring: "#ffe3db", icon:<WarningOutlined/> },
    warning: { fg: "#e0a100", bg: "#fff9e6", ring: "#ffefbf", icon:<WarningOutlined/> },
    success: { fg: "#0c8f47", bg: "#effbf4", ring: "#d8f4e5", icon:<CheckCircleFilled/> },
};
